<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Contract from "@/components/modals/contract-history.vue";

export default {
  page: {
    title: "Incoming Deliveries",
  },
  components: {
    Layout,
    PageHeader,
    Contract,
  },
  data() {
    return {
      title: "Incoming Deliveries",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Incoming Deliveries",
          active: true,
        },
      ],
      totalRows: 1,
      po: {
        id: null,
        description: "",
      },
      tableData: [],
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      loading: false,
      tabIndex: 0,
      selectedDU: this.$store.state.data.selectedDU.id,
      cycle: this.$store.state.data.cycle,
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.description.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.description
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (
            item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.poNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (
            item.supplierName.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.supplierName
              .toUpperCase()
              .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    },
  },
  created() {
    this.changeCampus();
  },
  methods: {
    changeCampus() {
      this.selectedDU = this.$store.state.data.selectedDU.id;
      this.cycle = this.$store.state.data.cycle;
      if (this.tabIndex == 0) this.getPending();
      else this.getCompleted();
    },
    getPending() {
      this.loading = true;
      var cycle = this.cycle;
      var deliveryUnitId = this.selectedDU;
      this.$store
        .dispatch("inspectioncontract/GetInspectionContractByDu", {
          cycle,
          deliveryUnitId,
        })
        .then((res) => {
          this.loading = false;
          res.data.forEach((x) => {
            x.loading = false;
            x.visible = false;
            x.toggleAll = false;
            x.allIarName = 0;
            x.rfqSupplierOffers = [];
            x.addDocu = false;
            x.attachmentLoading = false;
            x.poFiles = [];
            x.viewFile = false;
          });
          this.tableData = res.data.sort(function (a, b) {
            return b.expectedDelivery.localeCompare(
              a.expectedDelivery
            );
          });
        })
        .catch((err) => {
          this.showToast(
            "Something went wrong - Getting incoming deliveries!",
            "error"
          );
          this.loading = false;
        });
    },
    getCompleted() {
      this.loading = true;
      var cycle = this.cycle;
      var deliveryUnitId = this.selectedDU;
      this.$store
        .dispatch("inspectioncontract/GetInspectionContractCompletedByDu", {
          cycle,
          deliveryUnitId,
        })
        .then((res) => {
          this.loading = false;
          res.data.forEach((x) => {
            x.loading = false;
            x.visible = false;
            x.toggleAll = false;
            x.allSupplierOffer = true;
            x.allRequestedItem = false;
            x.rfqSupplierOffers = [];
            x.addDocu = false;
            x.attachmentLoading = false;
            x.poFiles = [];
            x.viewFile = false;
          });
          this.tableData = res.data.sort(function (a, b) {
            return b.expectedDelivery.localeCompare(a.expectedDelivery);
          });
        })
        .catch((err) => {
          this.showToast(
            "Something went wrong - Getting incoming deliveries!",
            "error"
          );
          this.loading = false;
        });
    },
    getRfqItems(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.loading = true;
        row.toggleAll = false;
        setTimeout(() => {
          this.$store
            .dispatch("rfqsupplieroffer/GetRSOWinner", row.rfqSupplierId)
            .then((res) => {
              res.data.forEach((y) => {
                y.iarName = 0;
                y.toggleSelected = false;
              });
              row.rfqSupplierOffers = res.data;
              row.loading = false;
            });
        }, 1000);
      }
    },
    getIarItems(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.loading = true;
        row.toggleAll = false;
        setTimeout(() => {
          this.$store
            .dispatch(
              "inspectioncontract/GetInspectionContractItemsCompleted",
              row.id
            )
            .then((res) => {
              row.rfqSupplierOffers = res.data.sort((a, b) =>
                a.itemName.localeCompare(b.itemName)
              );
              row.loading = false;
            });
        }, 1000);
      }
    },
    getSuspension(row) {
      this.$refs.contract.getSuspension(row, "VIEW");
      this.$bvModal.show("modal-contract");
    },
    checkDeliveryDate(deliveryDate, days) {
      var warningDays = days < 4 ? 1 : ~~(days / 4);
      var today = new Date();
      var nextweek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + warningDays
      );
      if (deliveryDate <= today) return "expired";
      else if (deliveryDate < nextweek) return "warning";
      else return "ongoing";
    },
  },
};
</script>
<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <b-tabs
      content-class="pt-3 pb-3 text-muted"
      v-model="tabIndex"
      nav-class="nav-tabs-custom"
    >
      <b-tab
        @click="
          getPending();
          filter = '';
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-clock-time-four-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Incoming</span>
        </template>
        <div v-if="tabIndex == 0">
          <div class="d-flex justify-content-between mb-2">
            <h4 class="m-0 pt-3">P.O. List</h4>
            <div class="d-flex align-items-center">
              <div id="tickets-table_filter" class="tableDatas_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search PO..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="tableDatas_length">
                <label class="d-inline-flex align-items-center">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <div
            class="h-50vh d-flex align-items-center justify-content-center"
            v-if="loading"
          >
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-25px h-25px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <h5 class="mb-0">Loading...</h5>
          </div>
          <div
            class="h-50vh d-flex align-items-center justify-content-center"
            v-else-if="paginated.length == 0"
          >
            <h5 v-if="filter != ''" class="text-muted">
              <i class="fas fa-exclamation-triangle me-2"></i>Search Not Found
            </h5>
            <h5 v-else class="text-muted">
              <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
            </h5>
          </div>
          <div v-else>
            <div role="tablist" v-for="x in paginated" :key="x.id">
              <b-card no-body class="mb-1 position-relative">
                <b-card-header header-tag="header" role="tab">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <div
                        class="d-flex align-items-center"
                        style="min-width: max-content"
                      >
                        <div class="text-white">PO# {{ x.poNumber }}</div>
                        <div class="ms-2">|</div>
                        <small class="ms-2">
                          {{ x.supplierName }}
                        </small>
                      </div>
                      <div class="text-white font-size-14 mb-1">
                        {{ x.description }}
                      </div>
                      <div
                        class="d-flex align-items-center"
                        style="min-width: max-content"
                      >
                        <div
                          v-b-tooltip.bottomleft.hover="
                            'Expected Date of Delivery'
                          "
                          class="badge bg-soft"
                          :class="
                            checkDeliveryDate(
                              new Date(x.expectedDelivery),
                              x.numberOfDays
                            ) == 'ongoing'
                              ? 'bg-success'
                              : checkDeliveryDate(
                                  new Date(x.expectedDelivery),
                                  x.numberOfDays
                                ) == 'warning'
                              ? 'bg-warning text-warning'
                              : 'bg-danger text-danger'
                          "
                        >
                          <b class="font-size-12">{{
                            formatDate(new Date(x.expectedDelivery))
                          }}</b>
                        </div>
                        <div class="ms-2">|</div>
                        <small class="ms-1">
                          <a
                            href="javascript: void(0);"
                            class="text-success d-flex align-items-center ms-1"
                            @click="getRfqItems(x)"
                          >
                            {{ x.visible ? "Hide" : "Show" }}
                            Items
                            <i
                              class="bx bx-chevron-right rotate font-size-14"
                              :class="{
                                'rotate-90': x.visible,
                              }"
                            ></i>
                          </a>
                        </small>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <a
                        href="javascript:void(0);"
                        class="action-icon text-warning hover-max-width d-flex align-items-center"
                        @click="getSuspension(x)"
                        ><i
                          class="mdi mdi-calendar-clock font-size-22 me-1"
                        ></i>
                        <span class="me-2">Contract Management</span>
                      </a>
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  :visible="x.visible"
                  :accordion="`pending-accordion-${x.id}`"
                  role="tabpanel"
                >
                  <b-card-body>
                    <div
                      v-if="x.loading"
                      class="p-3 d-flex align-items-center justify-content-center"
                    >
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-25px h-25px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <h5 class="mb-0">Loading...</h5>
                    </div>
                    <div
                      class="p-3 d-flex align-items-center justify-content-center"
                      v-else-if="x.rfqSupplierOffers.length == 0"
                    >
                      <h5 class="text-muted">
                        <i class="fas fa-exclamation-triangle me-2"></i>No Data
                        Found
                      </h5>
                    </div>
                    <div v-else>
                      <div class="mb-2">
                        <b class="mt-2 mb-1 font-size-16">Requested Items:</b>
                      </div>
                      <table width="100%">
                        <thead>
                          <tr>
                            <th class="py-2">
                              <div class="row m-0">
                                <div class="col-6 p-0 pe-5">
                                  Requested Item:
                                </div>
                                <div class="col-6 p-0 pe-5">
                                  Supplier Offer:
                                </div>
                              </div>
                            </th>
                            <th class="py-2" style="width: 250px">
                              Requisitioning Office/Dept.:
                            </th>
                            <th class="py-2" style="width: 150px">
                              Unit Price
                            </th>
                            <th class="py-2" style="width: 150px">
                              Items Remaining
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="y in x.rfqSupplierOffers"
                            :key="y.id"
                            class="border-top"
                          >
                            <td class="py-2">
                              <div class="row m-0">
                                <div class="col-6 p-0 pe-5">
                                  <div>{{ y.apiResource.itemName }}</div>
                                  <small>{{ y.apiResource.description }}</small>
                                </div>
                                <div class="col-6 p-0 pe-5">
                                  <div>{{ y.itemName }}</div>
                                  <small>{{ y.description }}</small>
                                </div>
                              </div>
                            </td>
                            <td class="py-2">
                              {{ x.deliveryUnit.name }}
                            </td>
                            <td class="py-2 text-warning">
                              {{ formatCurrency(y.unitCost) }}
                            </td>
                            <td class="py-2 text-info">
                              {{ y.availableItemsForIar }} of
                              {{ y.quantity }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <div class="row pt-3 pb-3">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="tableDatas_paginate paging_simple_numbers float-end"
                >
                  <ul class="paginate pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab
        @click="
          getCompleted();
          filter = '';
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-clock-time-four-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Delivered</span>
        </template>
        <div v-if="tabIndex == 1">
          <div class="d-flex justify-content-between mb-2">
            <h4 class="m-0 pt-3">P.O. List</h4>
            <div class="d-flex align-items-center">
              <div id="tickets-table_filter" class="tableDatas_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search PO..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="tableDatas_length">
                <label class="d-inline-flex align-items-center">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <div
            class="h-50vh d-flex align-items-center justify-content-center"
            v-if="loading"
          >
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-25px h-25px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <h5 class="mb-0">Loading...</h5>
          </div>
          <div
            class="h-50vh d-flex align-items-center justify-content-center"
            v-else-if="paginated.length == 0"
          >
            <h5 v-if="filter != ''" class="text-muted">
              <i class="fas fa-exclamation-triangle me-2"></i>Search Not Found
            </h5>
            <h5 v-else class="text-muted">
              <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
            </h5>
          </div>
          <div v-else>
            <div role="tablist" v-for="x in paginated" :key="x.id">
              <b-card no-body class="mb-1 position-relative">
                <b-card-header header-tag="header" role="tab">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <div class="text-white">PO# {{ x.poNumber }}</div>
                      <div class="text-white font-size-14">
                        {{ x.description }}
                      </div>
                      <small>
                        <a
                          href="javascript: void(0);"
                          class="text-success d-flex align-items-center"
                          @click="getIarItems(x)"
                        >
                          {{ x.visible ? "Hide" : "Show" }}
                          Details
                          <i
                            class="bx bx-chevron-right rotate font-size-14"
                            :class="{
                              'rotate-90': x.visible,
                            }"
                          ></i>
                        </a>
                      </small>
                    </div>
                    <div class="d-flex align-items-center">
                      <a
                        href="javascript:void(0);"
                        class="action-icon text-warning hover-max-width d-flex align-items-center"
                        @click="getSuspension(x)"
                        ><i
                          class="mdi mdi-calendar-clock font-size-22 me-1"
                        ></i>
                        <span class="me-2">Contract Management</span>
                      </a>
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  :visible="x.visible"
                  :accordion="`completed-accordion-${x.id}`"
                  role="tabpanel"
                >
                  <b-card-body>
                    <div
                      v-if="x.loading"
                      class="p-3 d-flex align-items-center justify-content-center"
                    >
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-25px h-25px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <h5 class="mb-0">Loading...</h5>
                    </div>
                    <div
                      class="p-3 d-flex align-items-center justify-content-center"
                      v-else-if="x.rfqSupplierOffers.length == 0"
                    >
                      <h5 class="text-muted">
                        <i class="fas fa-exclamation-triangle me-2"></i>No Data
                        Found
                      </h5>
                    </div>
                    <div v-else>
                      <div class="mb-2">
                        <b class="mt-2 mb-1 font-size-16">Requested Items:</b>
                      </div>
                      <table width="100%">
                        <thead>
                          <tr>
                            <th class="py-2">Item Name</th>
                            <th class="py-2" style="width: 120px">
                              Items Delivered
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="y in x.rfqSupplierOffers"
                            :key="y.id"
                            class="border-top"
                          >
                            <td class="py-2">
                              <div class="mb-1">
                                <div
                                  class="badge"
                                  :class="
                                    !y.isDelivered
                                      ? 'bg-danger'
                                      : y.iarStatus == 'PENDING'
                                      ? 'bg-secondary'
                                      : y.isPropertyCreated
                                      ? 'bg-success'
                                      : 'bg-purple'
                                  "
                                >
                                  <b class="font-size-10">{{
                                    !y.isDelivered
                                      ? "WAIVED"
                                      : y.iarStatus == "PENDING"
                                      ? "DELIVERED"
                                      : y.isPropertyCreated
                                      ? "COMPLETED"
                                      : "PROCESSING IAR"
                                  }}</b>
                                </div>
                              </div>
                              <div>{{ y.itemName }}</div>
                              <small>{{ y.description }}</small>
                            </td>
                            <td class="py-2 text-info">
                              {{ y.quantity }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <div class="row pt-3 pb-3">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="tableDatas_paginate paging_simple_numbers float-end"
                >
                  <ul class="paginate pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <contract ref="contract"></contract>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.paginate {
  z-index: -1 !important;
}

.tooltip {
  opacity: 1 !important;
}
</style>
